import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { AppLayoutComponent } from 'fg-library';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
    selector: 'fg-client-app-main-layout',
    styleUrls: ["./app-layout.component.scss"],
    templateUrl: './app-layout.component.html',
    standalone: false
})
export class FgClientAppLayoutComponent extends AppLayoutComponent {

@ViewChild("settingsDrawer") settingsDrawer!: MatDrawer;

openSettingsDrawer() {
  this.settingsDrawer.open();

}

  ngOnInit(): void {

    this.theming.theming$.subscribe(
      (newTheme => {
        if(newTheme) {
          this.theming.theme = newTheme;
          this.currentTheme = newTheme;
        } else {
          this.currentTheme = 'darkMono';
        }
      })
    )

    super.ngOnInit();
  }

}
